$(document).ready(function() {
	
	// braucht man damit on Resize auf die Desktop Variante die Filtergruppenüberschriften nicht mehr klickbar sind
	$(window).resize(function() {
		if ( $(window).width() >= 992 ) {
			$(".ttgColRight .ttgFilterAccordionGroupHeadline").unbind("click");
		}
	});
	
	$(".ttgAccordionContent").hide();
	$(".ttgAccordionContentOpen").show();
	$(".ttgFilterAccordionGroupHeadline").unbind("click").click(function() {
		// Funktionalität nur gewährleisten, wenn das Akkordeon-Pfeilchen sichtbar ist
		if ( $('.ttgFilterGroupArrow, .ttgFilterAccordionGroupHeadline row').css('display') == "block") {  
			if ($(this).find(".ttgGroupArrowDown")) {
				$(this).find(".ttgGroupArrow").removeClass("ttgGroupArrowDown").addClass("ttgGroupArrowUp");
			} // if
			if ($(this).find(".ttgGroupArrowUp") && $(this).next().css("display") == "block") { 
				$(this).find(".ttgGroupArrow").removeClass("ttgFilterGroupArrowUp").addClass("ttgFilterGroupArrowDown");
			} // if
			$(this).next().slideToggle("slow", function() {
			});
		} // if
	});
	
	//**********************************
	//ttgAccordion - Accordions - TOURDATA DETAILSEITEN
	//**********************************
	$('.ttgAccordionSectionTitle').click(function(e) {
		// Grab current anchor value
		var currentAttrValue = $(this).attr('href');
        //alert(currentAttrValue);
		
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(currentAttrValue).slideUp(300).removeClass('open');
		} else {
			//close_accordion_section();
 
			// Add active class to section title
			$(this).addClass('active');
			// Open up the hidden content panel
			$(currentAttrValue).slideDown(300).addClass('open');
		} // if-else
 
		e.preventDefault();
	});
	//**********************************
	//ttgAccordion - Accordion
	//**********************************
	
	//**********************************
	//ttgSubAccordion - TOURDATA DETAILSEITEN
	//**********************************
	$(".ttgSubAccordionTitle").click(function() {
		// Add active class to section title
		var sTitle = $(this);
		$(this).next().slideToggle("slow", function() {
			if (sTitle.hasClass("active")) { 
				sTitle.removeClass('active');
			} else {
				sTitle.addClass('active');
			} // if-else
		});
	});
	
	
	// Sofern das 1. Element in einem Tab ein Akkordeon ist, soll dieses geöffnet dargestellt werden
	if ( $('.ttgDetailTabsContent').length ) {
		$('.ttgDetailTabsContent').children().each(function(){
			if ( $(this).children().first().hasClass('ttgAccordion')) { 
				if ( $(this).children().first().children().first().hasClass('ttgIsRealAccordion') ) {
					$(this).children().first().children().first().children('.ttgAccordionSectionTitle').trigger('click');
				} // if
			} // if
		});
	} // if
	
});

